import AccountAndTenants from './accountAndTenants';

export class AccountAndTenantsInstanceResolver {
    private static _accountAndTenantsInstance: AccountAndTenants;

    public static Instantiate(accountAndTenantsInstance: AccountAndTenants) {
        if (!this._accountAndTenantsInstance) {
            this._accountAndTenantsInstance = accountAndTenantsInstance;
        }

        return this._accountAndTenantsInstance;
    }

    public static get Instance() {
        return this._accountAndTenantsInstance;
    }
}
